export const MembershipType = [
    { title: 'Recurring', value: 2 },
    { title: 'Bank', value: 1 },
    { title: 'Option Package', value: 3 }
]